export const AttachmentsTypeGuids = {
    EvdiTechnicalFile: "08D6F467-4241-42B3-A7AE-F9B452619BBE",
    CapacityPlan: "D81EBA48-ACFE-4D25-9F6C-2F545CB65012",
    CurrentClassCertificate: "273E4FC1-C443-4CE3-AA5E-E5558048AFE4",
    MainEngineShopTestFile: "E8C34AC2-DCEC-4839-88EA-213289BC3064",
    AuxiliaryEngineShopTestFile: "7F79DBC6-F064-41C2-A376-8D93B7BEA102",
    SeaTrialReport: "1A43145E-5CED-4C4F-BAF3-05F79491FF00",
    CertifiedDocument: "933694A9-8CCB-43AC-8385-1D398882B004",
    ReLiquefactionDocumentation: "46CC9D6D-A0DD-4033-9030-33B15450A2A0",
    EnergySavingEquipment: "F47344C2-0743-4FD2-9159-982650F174C9",
    Eexi: "D2C20A7B-30A5-4E30-897B-9089761F2CF3",
    Epl: "01814B30-FB5B-4E1F-8BBC-EB8364E08DD3",
    Cii: "655C202E-6FA9-42C9-A74D-55FAA9574F1A",
    CiiCorrectiveActionPlan: "46C11111-3F7F-4E89-89FC-266B5F798B22",
    EeCertificate: "7D541BFB-08EC-49F7-A11B-F1BF55AEE2DE"
}